<template>
  <!-- Loading -->
  <div class="vld-parent">
      <loading v-model:active="isLoading" :is-full-page="true" :height="128" :width="128" />
  </div>

  <div class="shadow overflow-hidden">
    <div>
      <dl>
        <div v-if="upload.submenu == 'Training'">
          <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('candidate.submenu') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ upload.submenu }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('vaccines.start_date') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ upload.start_date }}
            </dd>
          </div>

          <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('vaccines.end_date') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ upload.end_date }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('vaccines.description') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ upload.description }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('vaccines.assignment_no') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ upload.assignment_no }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('vaccines.certificate_no') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ upload.certificate_no }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('vaccines.certificate_exp_date') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ upload.certificate_exp_date }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-1 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              <a class="bg-blue-700 hover:bg-blue-700 text-white font-bold py-2 px-4" :href="upload.filename" download="assigment.pdf">
                Assigment Download
              </a>
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              <vue-pdf-embed :source="pdfSource" />
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-1 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              <a class="bg-blue-700 hover:bg-blue-700 text-white font-bold py-2 px-4" :href="upload.certificate_filename" download="certification_upload.pdf">
                Certificate Download
              </a>
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              <vue-pdf-embed :source="pdfSourceCertificate" />
            </dd>
          </div>

        </div>
        <div v-else>
          <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('candidate.submenu') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ upload.submenu }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('vaccines.description') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ upload.description }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-1 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              <a class="bg-blue-700 hover:bg-blue-700 text-white font-bold py-2 px-4" :href="upload.filename" download="upload.pdf">
                Download PDF
              </a>
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              <vue-pdf-embed :source="pdfSource" />
            </dd>
          </div>

        </div>

      </dl>

    </div>

  </div>

</template>
<script>
/* eslint-disable */
import { ref, reactive, watchEffect } from 'vue'
import { axiosDocument } from "@/boot/axios";
import VuePdfEmbed from 'vue-pdf-embed'
import Loading from 'vue-loading-overlay'
export default {
  name: 'ClassForm',
  components: {
    Loading,
    VuePdfEmbed
  },
  props: {
    propObject: {
        type: Object,
        default: () => ({ empty: true })
    }
  },
  data: function () {
    return {
    }
  },
  emits: ['close-modal', 'submit'],
  setup (props, { emit }) {
    const titleStack = ref(['Admin', 'Forms'])

    const upload = ref({})
    const isLoading = ref(false)

    // if doc academic active = true
    const storeDoc = (env) => {
        const url = 'doc-file-getEmployee'
        const method = 'POST'

        isLoading.value = true
        const paramsData = { id: env }

        const jsonData = JSON.stringify(paramsData)
        console.log('paramsData DOC', paramsData)

        const configHeaders = {
            'content-type': 'application/json',
            Accept: 'application/json'
        }

        axiosDocument({
            method,
            url,
            data: jsonData,
            headers: configHeaders
        })
        .then(response => {
            isLoading.value = false
            pdfSource.value = response.data.data
            pdfSourceCertificate.value = response.data.data_certificate
            console.log('pdfSource.value', pdfSource.value)
        })
        .catch(error => {
            isLoading.value = false
            console.log('error', error)
        })
    }

    const pdfSource = ref(null)
    const pdfSourceCertificate = ref(null)
    watchEffect(() => {
      upload.value = props.propObject
      
      if(upload.value && upload.value.is_doc > 0){
        storeDoc(upload.value.id)
      } else {
        if (upload.value && upload.value.filename) {
          pdfSource.value = upload.value.filename
        }
        if (upload.value && upload.value.certificate_filename) {
          pdfSourceCertificate.value = upload.value.certificate_filename
        }
      }
    })

    return {
      isLoading,
      storeDoc,
      titleStack,
      upload,
      pdfSource,
      pdfSourceCertificate

    }
  }
}
</script>